module.exports = __webpack_public_path__ + "img/Path 10@3x.5456f765.png";